import React from "react";

export const BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS = ["Masseter", "CO2", "O2"];

export const normalizeBookingAdditionalEquipment = (value) =>
  BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS.filter(
    (option) => Array.isArray(value) && value.includes(option),
  );

export const readBookingAdditionalEquipment = (inputRefs, currentValue) => {
  const selected = normalizeBookingAdditionalEquipment(currentValue);
  return BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS.filter((option) =>
    inputRefs[option].current
      ? inputRefs[option].current.checked
      : selected.includes(option),
  );
};

export const BookingAdditionalEquipmentField = ({
  value,
  inputRefs,
  idPrefix,
  disabled = false,
}) => {
  const selected = normalizeBookingAdditionalEquipment(value);
  return (
    <div
      className="form-group row"
      role="group"
      aria-labelledby={`${idPrefix}-label`}
    >
      <span className="col-lg-3 col-form-label" id={`${idPrefix}-label`}>
        Additional equipment
      </span>
      <div className="col-lg-9">
        <div className="d-flex flex-wrap align-items-center pt-2">
          {BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS.map((option) => (
            <div className="custom-control custom-checkbox mr-4" key={option}>
              <input
                type="checkbox"
                className="custom-control-input"
                id={`${idPrefix}-${option}`}
                ref={inputRefs[option]}
                defaultChecked={selected.includes(option)}
                disabled={disabled}
                aria-describedby={`${idPrefix}-help`}
              />
              <label
                className="custom-control-label"
                htmlFor={`${idPrefix}-${option}`}
              >
                {option}
              </label>
            </div>
          ))}
        </div>
        <small className="form-text text-muted" id={`${idPrefix}-help`}>
          {disabled
            ? "Equipment required for this study."
            : "Select any equipment required for this study."}
        </small>
      </div>
    </div>
  );
};

const BookingAdditionalEquipment = ({ value, compact = false }) => {
  const selected = normalizeBookingAdditionalEquipment(value);
  if (compact && selected.length === 0) return null;
  return (
    <span
      className={compact ? "d-block small mt-1" : undefined}
      title={selected.length
        ? `Additional equipment required: ${selected.join(", ")}`
        : undefined}
    >
      {compact && <span className="text-muted">Additional equipment: </span>}
      {selected.length ? selected.map((option) => (
        <span className="badge badge-info mr-1" style={{ fontSize: "inherit" }} key={option}>
          {option}
        </span>
      )) : <span className="text-muted">None</span>}
    </span>
  );
};

export default BookingAdditionalEquipment;
